module.exports = __webpack_public_path__ + "static/media/buildingsIOT.92f9cd66.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/shared/buildingsIOT.png
// module id = 74
// module chunks = 0